import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import { useNavigate, useParams } from "react-router-dom";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import PageChanger from "../../Helpers/Components/Pagination";
import Select from 'react-select'
import Handler from "../../Helpers/Components/Handler";

const List = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [subadminList, setSubadminList] = useState([])
    const [checkDate, setCheckDate] = useState()
    const [total, setTotal] = useState(0)
    const calendarRef = useRef();
    const [filter, setFilter] = useState({
        count: 10,
        sortBy: "customerId",
        sort: true,
        search: "",
        createdBy: "All",
        custType: "All",
        type: "All",
        remarks: "All",
        custStatus: "All",
        status: "All"
    })
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    }
    const handleOpen = () => {
        if (calendarRef.current) calendarRef.current.openCalendar();
    };
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
    }
    const getSubadminList = async () => {
        const response = await Handler({ method: "get", url: `/customer/details/get-subadmin`, })
        if (response?.success) {
            setSubadminList(response?.data)
        } else {
            setSubadminList([])
        }
    }
    const getCustomerDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/customer/request/list/${pageNo - 1}?count=${filter?.count || 10}`,
            data: {
                ...(checkDate?.length ? { from: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
                ...(filter?.createdBy !== "All" ? { createdId: filter?.createdBy } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy
            }
        })
        if (response?.success) {
            setCustDetails(response?.data?.current)
            setNext(response?.data?.next)
            setTotal(response?.data?.total)
        } else {
            setCustDetails([])
            setNext(false)
            setTotal(0)
        }
        setLoading(false)
    }
    const setPageNo = (value) => navigate(`/req-data/${value}`)
    useEffect(() => {
        getCustomerDetails()
    }, [pageNo, filter, checkDate])
    useEffect(() => {
        getSubadminList()
    }, [])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Requested Data</h5>
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        <div>Total Customer: {total}</div>
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "customerId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("customerId", false)} >▲</i><i className={filter?.sortBy === "customerId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("customerId", true)} >▼</i></div> Cust Id</div></th>
                                <th> Cust Name</th>
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "createdAt" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("createdAt", false)} >▲</i><i className={filter?.sortBy === "createdAt" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("createdAt", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Created At <i className="fa-solid fa-caret-down"></i></button> </div></th>
                                <th>
                                    <DropdownToggle label={
                                        <> Created By <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.createdBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("createdBy", "All") }} />
                                        {
                                            subadminList?.length ?
                                                subadminList?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.name} className={`${filter?.createdBy === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("createdBy", element?.id) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row`}>
                                            <td><a className="" href={`/req-data/view/${value?.requestId}`}>{value?.customerId}</a></td>
                                            <td>
                                                <div className="text-capitalize">{((value?.firstName || "") + " " + (value?.lastName || ""))}</div>
                                                <div className="text-capitalize">{value?.secDetails?.name || ""}</div>
                                            </td>
                                            <td>{value?.createdAt ? moment(value?.createdAt).format('DD/MM/YYYY') : "-"}</td>
                                            <td className="text-capitalize">{value?.createdBy || ""}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={4}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={4} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='customer' />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setCheckDate({}),
                    },
                ]}
            />
        </React.Fragment>
    )
}

export default List;